module.exports = __webpack_public_path__ + "media/images/placeholder-messages-467d63c7.png";